var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusActionRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#DC1515"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5751"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1879",
    x: 8,
    y: 4,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#FAFBEF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 9,
    cy: 12,
    r: 1,
    fill: "#FAFBEF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusActionRequired);
export default __webpack_public_path__ + "static/media/status-action-required.ad882b11.svg";
export { ForwardRef as ReactComponent };